import React, { Component } from 'react'
import {Helmet} from "react-helmet";
import '../styles/courseDetails.css'

export default class CourseDetails extends Component {
    render() {
        return (
            <>
                <Helmet>
                    <title>Course Details</title>
                </Helmet>
                <div className="course-details inner">
                    <div className="container">
                        <h5><i class="far fa-file-alt"></i> Course Details</h5>
                        <div className="summary">
                            <div className="row">
                                <div className="col-md-3 col-12">
                                    <b><i class="far fa-circle"></i> Course Name</b>
                                    <div className="image text-center">
                                        <img src="../images/onlinecourse.jpg" alt="image" />
                                    </div>
                                    <div className="text-center">
                                        <a className="download" href="../images/onlinecourse.jpg" download><i class="fas fa-download"></i> Download</a>
                                    </div>
                                </div>
                                <div className="col-md-3 col-12">
                                    <b><i class="fas fa-braille"></i> Details</b>
                                    <ul class="list-unstyled text-left">
                                        <li class="category"><i class="fas fa-clone"></i> Category</li>
                                        <li class="branch"><i class="fas fa-cubes"></i> Topic</li>
                                        <li class="branch"><i class="fas fa-user"></i> Instructor</li>
                                        <li class="time"><i class="far fa-clock"></i> 00 Hour</li>
                                        <li class="branch"><i class="fas fa-headphones-alt"></i> Lectures : 00</li>
                                    </ul>
                                </div>
                                <div className="col-md-6 col-12">
                                <b><i class="fas fa-angle-right"></i> Contents</b><br/>
                                    <div className="table-responsive">
                                <table class="table table-striped">
                                <thead>
                                    <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Numbers</th>
                                    <th scope="col">Lectures</th>
                                    <th scope="col">Lecture Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <th scope="row">1</th>
                                    <td>Lecture 01</td>
                                    <td>Title</td>
                                    <td>Duration</td>
                                    </tr>
                                    <tr>
                                    <th scope="row">2</th>
                                    <td>Lecture 02</td>
                                    <td>Title</td>
                                    <td>Duration</td>
                                    </tr>
                                    <tr>
                                    <th scope="row">3</th>
                                    <td>Lecture 03</td>
                                    <td>Title</td>
                                    <td>Duration</td>
                                    </tr>
                                </tbody>
                                </table>
                                </div>
                                <div className="text-center">
                                    <button className="btn btn-info m">More</button>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="description">
                            <b><i class="fas fa-align-left"></i> Summary</b>
                            <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                            </p>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
